import {
    SKIP_ARGUMENTS,
    ONLY_CUSTOM_ARGUMENTS,
    toolSupportsElements,
} from '../../components/AutomationStudio/constant';

function isEmpty(value) {
    return (
        value === undefined ||
        value === null ||
        value === '' ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && value.length === 0)
    );
}

/**
 * Validate tool + required arguments for every step in the plan draft.
 * Custom steps also require ONLY_CUSTOM_ARGUMENTS (selector, etc.) when present in schema.
 */
export function validatePlanSteps(instructions = [], toolMap = {}) {
    let isValid = true;
    const errorsByStepId = {};

    for (const inst of instructions) {
        if (inst.removedFromEditor) continue;
        for (const step of inst.aiSteps ?? []) {
            const stepId = step.id;
            if (!stepId) continue;

            const isCustomStep = step.customStep === true;
            const toolError = !step.tool ? 'Tool is required' : '';
            if (!step.tool) isValid = false;

            const argsError = [];
            const args = step.args ?? step.arguments ?? {};
            const schema =
                step.tool && toolMap?.[step.tool] ? toolMap[step.tool] : null;
            const requiredKeys =
                schema && typeof schema === 'object'
                    ? Object.keys(schema).filter((key) => schema[key]?.required)
                    : [];

            Object.entries(args).forEach(([key, value]) => {
                if (value === undefined || value === null || SKIP_ARGUMENTS.includes(key)) {
                    return;
                }
                const isRequired =
                    schema?.[key]?.required ||
                    (isCustomStep &&
                        toolSupportsElements(step.tool) &&
                        ONLY_CUSTOM_ARGUMENTS.includes(key) &&
                        schema?.[key]);
                if (isEmpty(value) && isRequired && !SKIP_ARGUMENTS.includes(key)) {
                    argsError.push(key);
                    isValid = false;
                }
            });

            requiredKeys.forEach((key) => {
                if (SKIP_ARGUMENTS.includes(key) || argsError.includes(key)) return;
                if (isEmpty(args[key])) {
                    argsError.push(key);
                    isValid = false;
                }
            });

            if (isCustomStep && schema && toolSupportsElements(step.tool)) {
                ONLY_CUSTOM_ARGUMENTS.forEach((key) => {
                    if (!schema[key] || argsError.includes(key)) return;
                    if (isEmpty(args[key])) {
                        argsError.push(key);
                        isValid = false;
                    }
                });
            }

            errorsByStepId[stepId] = {
                toolError: toolError || undefined,
                argsError: argsError.length ? argsError : undefined,
            };
        }
    }

    return { isValid, errorsByStepId };
}

export function stepHasValidationErrors(errors) {
    if (!errors || typeof errors !== 'object') return false;
    if (errors.toolError) return true;
    if (Array.isArray(errors.argsError) && errors.argsError.length > 0) return true;
    if (errors.stepError) return true;
    return false;
}
